define(['../featuredetection/ApplicationFeatures'], ApplicationFeatures => {
    const trackingConfig = ApplicationFeatures.getAllFeatures().tracking;

    /**
     * Check if service is enabled in a portal's configuration
     */
    function isEnabled(serviceName) {
        return !!(trackingConfig || {})[serviceName];
    }

    function getCredentials(serviceName) {
        if (!isEnabled(serviceName)) return {};
        try {
            return require(`credentials/${serviceName}.credentials.json`);
        } catch (error) {
            throw Error(`Please include ${serviceName}.credentials.json in the credentials directory.`);
        }
    }

    return {
        getCredentials,
        $get: () => getCredentials
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/CredentialsProvider.js